"use client"
import React, {useState} from 'react'
import {Button, Modal, Form} from "components/ui";
import {FaChevronRight} from "react-icons/fa";
import {useTekstClient} from "hooks/useTekstClient";
import {useAxios} from "hooks/useAxios";
export const VerstuurEmail = () => {
    const [showModalMail, setShowModalMail] = useState(false);
    const [showModalMailLoading, setShowModalMailLoading] = useState(false);
    const [showModalMailInputEmail, setShowModalMailInputEmail] = useState('');
    const [showModalMailInputOnderwerp, setShowModalMailInputOnderwerp] = useState('');
    const {tekst} = useTekstClient()
    const {post} = useAxios()

    const verzendTestEmail = () => {
        setShowModalMailLoading(true);
        post(`${process.env.NEXT_PUBLIC_BACKEND}/api/onderhoud/mail-test`, {
            'email': showModalMailInputEmail,
            'onderwerp': showModalMailInputOnderwerp,
        }).finally(() => {
            setShowModalMail(false)
            setShowModalMailLoading(false)
        })
    }

    return <>
        <button
            type="button"
            className="btn btn-primary mt-3 flex items-center justify-between py-3 px-4 pr-5 max-w-[80%] font-bold"
            onClick={() => setShowModalMail(true)}
        >
            <span>{tekst('pagina:support:tools:email:button')}</span>
            <span className="ml-2 shrink-0"><FaChevronRight/></span>
        </button>
        <Modal
            size="lg"
            show={showModalMail}
            onHide={() => setShowModalMail(false)}
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header style={{border: 'none'}} onClick={() => setShowModalMail(false)}>
                <Modal.Title>Verstuur test email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Het is alleen toegestaan deze handeling te doen als MKG Medewerker.</p>

                <Form>
                    <Form.Group className="mb-3 flex gap-3" controlId="formBasicEmail">
                        <Form.Label className={`text-bold`}>Email adres:</Form.Label>
                        <Form.Control  name="email"
                                       type="email"
                                       label="Ontvanger"
                                       onChange={(e) => setShowModalMailInputEmail(e.target.value)}
                                       isrequired={true}
                                       placeholder={'voorbeeld@mkg.nl'}
                                       value={showModalMailInputEmail} />
                    </Form.Group>

                    <Form.Group className="mb-3 flex gap-3" controlId="formBasicEmail">
                        <Form.Label>Onderwerp:</Form.Label>
                        <Form.Control
                            name="onderwerp"
                            type="text"
                            label={"Onderwerp"}
                            placeholder={'Vul een onderwerp in..'}
                            onChange={(e) => setShowModalMailInputOnderwerp(e.target.value)}
                            isrequired={true}
                            value={showModalMailInputOnderwerp}
                        />
                    </Form.Group>

                </Form>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => setShowModalMail(false)}
                        variant="secondary">{tekst('algemeen:Annuleren')}</Button>
                <Button
                    onClick={verzendTestEmail}
                    variant="primary"
                    disabled={showModalMailLoading}
                >{showModalMailLoading ? tekst('algemeen:laden') : tekst('algemeen:Verzenden')}</Button>
            </Modal.Footer>
        </Modal>
    </>
}
